<template>
  <div>
    <change-file-list
      v-if="!disabled"
      :question="question"
      :question-index="questionIndex"
      :context-menu-container="contextMenuContainer"
      :type="type"
      :prepend-files="prependFiles"
      :files="files"
      :upload-data="uploadData"
      :get-lable-data="getLableData"
      :datetime="datetime"
      @change="onChange"
      @draw-saved="onDrawSaved"/>
    <view-file-list
      v-else
      :question="question"
      :question-index="questionIndex"
      :context-menu-container="contextMenuContainer"
      :type="type"
      :prepend-files="prependFiles"
      :files="files"
      :get-lable-data="getLableData"/>
  </div>
</template>

<script>
import ChangeFileList from './ChangeFileList'
import ViewFileList from './ViewFileList'

export default {
  components: {ChangeFileList, ViewFileList},
  mixins: [],
  props: {
    disabled: Boolean,
    question: Object,
    questionIndex: Number,
    files: Array,
    prependFiles: Array,
    type: String,
    uploadData: Object,
    contextMenuContainer: Element,
    getLableData: Function,
    datetime: String,
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  destroyed () {},
  methods: {
    onChange (val) {
      this.$emit('change', val)
    },
    onDrawSaved (payload) {
      this.$emit('draw-saved', payload)
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/AnswerFileList/index.vue